module.exports = __webpack_public_path__ + "assets/img/kv-024fba46.jpg";